<template>
  <div>
    <h1 class="mb-30">Настройки</h1>

    <ul class="card-list">
      <li
        v-for="(item, index) in settingsList"
        :key="index"
        class="card-list__item"
      >
        <router-link
          class="card-list__link"
          :to="{ name: item.routeName }"
        >
          {{ item.title }}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { SETTINGS_LIST } from '@/const/settingsList'

export default {
  computed: {
    settingsList () {
      return Object.values(SETTINGS_LIST)
    }
  }
}
</script>
